import type { FC } from 'react';
import NudosConfirmActionModal from '../../../components/NudosComponents/NudosConfirmActionModal/NudosConfirmActionModal';
import useCatalogueState from '../../../state/useCatalogueState';

interface ActiveOrInactiveConfirmModalProps {
  secondButtonAction: () => void;
  firstButtonAction: () => void;
  isLoading?: boolean;
  isSingleActiveProduct?: boolean | null;
}

const ActiveOrInactiveConfirmModal: FC<ActiveOrInactiveConfirmModalProps> = ({
  secondButtonAction,
  firstButtonAction,
  isLoading = false,
  isSingleActiveProduct = null
}) => {
  const { activeProducts } = useCatalogueState();
  const renderfirstButtonText = 'No, dejar así';
  const renderSecondButtonText = isSingleActiveProduct ?? activeProducts ? 'Sí, inactivar' : 'Sí, activar';

  const renderNotificationQuestion =
    isSingleActiveProduct ?? activeProducts
      ? '¿Estás seguro que quieres inactivar este SKU? Perderás los precios actualmente agregados, ya no podrás venderlo y el cliente no podrá cargarlo como herramienta externa'
      : '¿Estás seguro que quieres activar estos SKUs en Catálogo?Recuerda que si lo activas podrás venderlo o dejarlo disponible para cargue de herramientas externas';
  return (
    <NudosConfirmActionModal
      firstButtonAction={firstButtonAction}
      secondButtonAction={secondButtonAction}
      firstButtonText={renderfirstButtonText}
      secondButtonText={isLoading ? 'Cargando...' : renderSecondButtonText}
      modalText={renderNotificationQuestion}
    />
  );
};

export default ActiveOrInactiveConfirmModal;
